import { getLogger } from '@arcivr/sp-ui-lib'

export default getLogger('sales-analytics-ui')
